import * as React from "react";

const SvgSave = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 400 400"
    width="24px"
    height="24px"
    {...props}
  >
    <path d="M246.3,107.4H115.9c-4.7,0-8.5,3.8-8.5,8.5v168.3c0,4.7,3.8,8.5,8.5,8.5h168.3c4.7,0,8.5-3.8,8.5-8.5v-130.5l-46.3-46.3ZM224.1,117.4v37.1h-80.2v-37.1h80.2ZM143.9,282.6v-72.6h112.3v72.6h-112.3ZM282.6,282.6h-16.5v-74.1c0-4.7-3.8-8.5-8.5-8.5h-115.2c-4.7,0-8.5,3.8-8.5,8.5v74.1h-16.5V117.4h16.5v38.6c0,4.7,3.8,8.5,8.5,8.5h83.2c4.7,0,8.5-3.8,8.5-8.5v-38.6h8.1l40.5,40.5v124.8Z" />
  </svg>
);

export default SvgSave;
